import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { FooterBar } from 'src/app/components/Elements/FooterBar';
import { medications, shop2 } from 'src/app/router/paths';
import { arePathnamesEqual } from 'src/app/utils';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { TabbedButtonContainer, TabButtonHeader } from './styles';

export interface TabbedFooterBarProps {
  currentPath: string;
}

export const TabbedFooterBar = ({ currentPath }: TabbedFooterBarProps) => {
  const isMedicationsPath = arePathnamesEqual(currentPath, medications.toPath());
  const isEssentialsPath = arePathnamesEqual(currentPath, shop2.toPath());

  return (
    <FooterBar>
      <TabbedButtonContainer to={medications.toPath()}>
        <CapsuleIcon
          iconString={isMedicationsPath ? CAPSULE_ICON_STRINGS.rx_filled : CAPSULE_ICON_STRINGS.rx_outline}
        />
        <TabButtonHeader highlighted={isMedicationsPath}>Prescriptions</TabButtonHeader>
      </TabbedButtonContainer>
      <TabbedButtonContainer to={shop2.toPath()}>
        <CapsuleIcon
          iconString={isEssentialsPath ? CAPSULE_ICON_STRINGS.otc_filled : CAPSULE_ICON_STRINGS.otc_outline}
        />
        <TabButtonHeader highlighted={isEssentialsPath}>Essentials</TabButtonHeader>
      </TabbedButtonContainer>
    </FooterBar>
  );
};
